import { sendRequest } from "../../hooks/requests/useRequest";

export async function GetTimesCurve (_id_exam)
{
    const requestOptions = {
        method: "GET",
    };

    const response = await sendRequest(requestOptions, `Exam/GetTimesCurve/${_id_exam} `);

    if (response.code === 200)
        return {
            code: response.code,
            data: response.data
        }
    else if (response.code === 401)
        return response.code;
    else
        return {
            code: response.code,
            msg: response?.data?.msg
        };
}

export async function GetMethodsCurve (_id_exam)
{
    const requestOptions = {
        method: "GET",
    };

    const response = await sendRequest(requestOptions, `Exam/GetMethodsCurve/${_id_exam} `);

    if (response.code === 200)
        return {
            code: response.code,
            data: response.data,
        }
    else if (response.code === 401)
        return response.code;
    else
        return {
            code: response.code,
            msg: response?.msg
        };
}


export async function sendCurves(
    _array,
) {
   
   const transformedData = {
    id_exam: _array?.id_exam,
    id_info_analyte: _array?.id_info_analyte?.value ?? 0,
    num_sampligs: _array?.takes ?? 0,
    id_unit: _array?.id_unit === null ? null : _array?.id_unit.value ??  null,
    num_decimals: _array?.num_decimals  ??  0,
    samplings: _array?.arrayCurves?.map(child => ({
        num_sample: child.id,
        id_curve_time: child.tiempo?.value || false,
    })) || []
};
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(transformedData),
    };
    const response = await sendRequest(
        requestOptions, "Exam/CreateOrUpdateCurves"
    );

    if (response.code === 200)
        return {
            code: response.code,
            data: response?.data
        }
    else if (response.code === 401)
        return response.code;
    else
        return {
            code: response.code,
            data: response?.data
        }
}

export async function sendInfoAnalyteRanges(_array) {

  const transformedData = {
    id_info_analyte: _array?.id_info_analyte?.value ?? 0,
    id_method: _array?.id_methodCurve?.value ?? 0,
    ranges: _array?.arrayCurvesRanges
        ?.filter(sub => sub.id_method?.value === _array?.id_methodCurve?.value)
        .map(child => {
            const years_from = child?.years_from ?? 0;
            const months_from = child?.months_from ?? 0;
            const days_from = child?.days_from ?? 0;
            const years_to = child?.years_to ?? 0;
            const months_to = child?.months_to ?? 0;
            const days_to = child?.days_to ?? 0;

            return {
                id_curve_time: child?.tiempo?.value ?? 0,
                label_curve_time: child?.tiempo?.label ?? "",
                min: child?.min !== "" ? Number(child.min) : null,
                max: child?.max !== "" ? Number(child.max) : null,
                text: child?.text ?? null,
                id_gender: child?.id_gender ?? null,

                years_from,
                months_from,
                days_from,
                years_to,
                months_to,
                days_to,

                total_days_from: (years_from * 365) + (months_from * 30) + days_from,
                total_days_to: (years_to * 365) + (months_to * 30) + days_to,
            };
        }) ?? [],
};


    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(transformedData),
    };

    const response = await sendRequest(
        requestOptions,
        "Exam/CreateOrUpdateInfoAnalyteRanges"
    );

    if (response.code === 200) {
        return {
            code: response.code,
            data: response?.data
        };
    } else if (response.code === 401) {
        return response.code;
    } else {
        return {
            code: response.code,
            data: response?.data
        };
    }
}


export async function GetCurves(_id_exam) {
    const requestOptions = {
        method: "GET",
    };

    const response = await sendRequest(requestOptions, `Exam/GetCurves/${_id_exam}`);

    if (response.code === 200 && response.data) {
        const curveData = response.data;

        const transformedData = {
            id_info_analyte: {
                value: curveData.id_info_analyte,
                label: curveData.name_info_analyte || ""
            },
            id_unit: curveData.id_unit
                ? {
                    value: curveData.id_unit,
                    label: curveData.name_unit || ""
                }
                : null,
            takes: curveData.num_sampligs,
            num_decimals: curveData.num_decimals ?? 0,
            arrayCurves: curveData.samplings.map((sampling) => ({
                id: sampling.num_sample,
                tiempo: {
                    value: sampling.id_curve_time,
                    label: sampling.label_curve_time
                },
                min: 0,
                max: 0,
                text: ""
            })),
            isEdit: curveData.samplings.length > 0 ? true : false

        };

        return {
            code: 200,
            data: transformedData
        };
    }

    return {
        code: response.code,
        msg: response?.data?.msg || "Error al obtener curvas"
    };
}

export async function GetCurveInfoAnalyteRanges(id_exam) {
    const requestOptions = { method: "GET" };
    const response = await sendRequest(requestOptions, `Exam/GetCurveInfoAnalyteRanges/${id_exam}`);

    if (response.code === 200) {
        const arrayCurves = response.data.flatMap(method =>
            method.ranges.map(item => ({
                id_time: item.id_curve_time,
                tiempo: { value: item.id_curve_time, label: item.label_curve_time ?? "" },
                min: item.min ?? "",
                max: item.max ?? "",
                text: item.text ?? "",
                id_gender: item.id_gender ?? null,
                years_from: item.years_from ?? 0,
                months_from: item.months_from ?? 0,
                days_from: item.days_from ?? 0,
                years_to: item.years_to ?? 0,
                months_to: item.months_to ?? 0,
                days_to: item.days_to ?? 0,
                id_method: { value: method.id_method, label: method.label_method },
                id_info_analyte: { value: method.id_info_analyte, label: method.label_info_analyte }
            }))
        );

        const id_methodCurve = response.data.length
            ? { value: response.data[0].id_method, label: response.data[0].label_method }
            : null;

        return { code: response.code, arrayCurves, id_methodCurve };
        
    }

    return response.code === 401 ? response.code : {
        code: response.code,
        msg: response?.data?.msg || "Ocurrió un error al obtener los valores de referencia",
    };
}



export async function ResetComplexAnalyte(_id_analyte) {
    const requestOptions = {
        method: "POST",
    };

    const response = await sendRequest(requestOptions, `Exam/ResetComplexAnalyte/${_id_analyte}`);

    if (response.code === 200) {
        return {
            code: response.code,
            msg: response.data?.msg ?? "Fórmulas reseteadas correctamente",
        };
    } else if (response.code === 401) {
        return response.code;
    } else {
        return {
            code: response.code,
            msg: response?.data?.msg ?? "Error al resetear fórmulas",
        };
    }
}